<template>
	<div>
		<div class="container-node-headline">
			<p>
				<span
					class="senaryon-icon senaryon-icon-edit-curves senaryon-icon--with-right-margin"
				></span>
				<span>
					<!-- @vue-expect-error --> {{ dataNode.data.measure_name }}</span
				>
			</p>
		</div>
		<!-- @vue-expect-error -->
		<drawflow-top-right-tags
			:tags-to-show="tagsToShow"
			:modal-id="modalId"
			:parent-instance="this"
		></drawflow-top-right-tags>
		<div
			class="drawflow-node drawflow-node--nested"
			v-for="childNode in childNodes"
			v-bind:key="childNode.id"
			:id="childNode.id"
		>
			<div class="drawflow_content_node">
				<!-- @vue-expect-error -->
				<drawflow-measure-item
					:data-node="childNode"
					:drawflow-instance="drawflowInstance"
				></drawflow-measure-item>
			</div>
		</div>
	</div>
</template>

<script>
import DrawflowHelpers from "./drawflow_helpers";
import DrawflowMeasureItem from "./drawflow_measure_item.vue";
import DrawflowTopRightTags from "./drawflow_top_right_tags.vue";

export default {
	props: {
		dataNode: Object,
		drawflowInstance: Object,
		modalId: {
			type: String,
			default: "#replace-me",
		},
	},
	components: {
		"drawflow-measure-item": DrawflowMeasureItem,
		"drawflow-top-right-tags": DrawflowTopRightTags,
	},
	computed: {
		tagsToShow() {
			return this.drawflowInstance.editor_mode == "edit"
				? ["delete", "duplicate", "addMeasureOption"]
				: [];
		},
	},
	data: function () {
		return {
			childNodes: Object.values(this.dataNode.child_nodes),
		};
	},
	methods: {
		callPositionNode() {
			DrawflowHelpers.positionNode(this);
		},
		addMeasureOptionNodesToCanvas() {
			Object.values(this.dataNode.child_nodes).forEach((childNode) => {
				this.drawflowInstance.drawflow.drawflow[
					this.drawflowInstance.module
				].data[childNode.id] = childNode;
			});
		},
	},
	mounted() {
		// pp.log("mounted drawflow_measure_with_options_item", this.dataNode);
		setTimeout(() => {
			// Move this to the end of the stack so that the $domEl can be appended to `.container-node` in drawflow.js first
			DrawflowHelpers.addToDagre(
				this.drawflowInstance,
				this.dataNode,
				this.$el.closest(".container-node"),
			);
		});
		this.addMeasureOptionNodesToCanvas();

		pp.vue.bus.$on("DRAWFLOW-graph-changed", this.callPositionNode);
		pp.vue.bus.$on("DRAWFLOW-child-nodes-changed", (data) => {
			if (data.nodeId == this.dataNode.id) {
				pp.log("drawflow_measure_with_options_item change", data, this);
				this.childNodes = []; // Need to destroy child Vue instances first

				this.$nextTick(() => {
					this.childNodes = Object.values(this.dataNode.child_nodes);
					this.addMeasureOptionNodesToCanvas();
				});
			}
		});
	},
};
</script>
